<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info-view :detail-data="detailInfo" />
    <apply-for-shipment :detail-data="detailInfo" :detail-id="detailInfo.id" :region-business-commissioner-id="detailInfo.regionBusinessCommissionerId" />
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import baseInfoView from './baseInfoView.vue';
import applyForShipment from './applyForShipment.vue';
import { getContractDetailAllInfoByConNum } from '@/API';

export default {
  components: {
    baseInfoView,
    applyForShipment
  },

  data () {
    return {
      loading: false,
      detailInfo: { id: 0, regionBusinessCommissionerId: '' }
    };
  },

  computed: {
    ...mapState({
      user: state => state.user //  业务实体列表-来款记录查询(财务)
    }),

    // 商务权限
    isAssistant () {
      return this.user.perssimionCodeList.some(i => i === 'assistantContractList');
    }
  },

  created () {
    this.initData();
  },

  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.$route.query.contractNum).then((res) => {
        let { status, data } = res.data;
        this.loading = false;
        if (status === '200') {
          this.detailInfo = data;
        }
      }).catch(() => {
        this.loading = false;
      });
    }

  }

};
</script>
